const hasOwnProperty = Object.prototype.hasOwnProperty;

export function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}

export const isEmpty = function (val) {
    // null or undefined
    if (val == null) return true;
    // boolean
    if (typeof val === 'boolean') return false;
    // number
    if (typeof val === 'number') return !val;
    // errors
    if (val instanceof Error) return val.message === '';
    // objects
    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]': {
            return !val.length;
        }
        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]': {
            return !val.size;
        }
        // Plain Object
        case '[object Object]': {
            return !Object.keys(val).length;
        }
        default: {
            break;
        }
    }
    return false;
};
